type Props = {
	date: number;
	cInDatePanelContentChildren: React.ReactNode;
	cOutDatePanelContentChildren: React.ReactNode;
	stayDatePanelContentChildren: React.ReactNode;
	dayTripCInDatePanelContentChildren: React.ReactNode;
};

export const CalendarPanel = ({
	date,
	cInDatePanelContentChildren,
	cOutDatePanelContentChildren,
	stayDatePanelContentChildren,
	dayTripCInDatePanelContentChildren,
}: Props) => {
	return (
		<div className="space-y-0.5 rounded border p-2">
			<div className="border-b px-2 text-center">
				<p className="font-bold">{date}</p>
			</div>

			<div className="space-y-1">
				{cInDatePanelContentChildren}

				{cOutDatePanelContentChildren}

				{stayDatePanelContentChildren}

				{dayTripCInDatePanelContentChildren}
			</div>
		</div>
	);
};
